import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { AgreementCategoryStaff } from "./AgreementCategoryStaff";
import type { CatalogItemCategoryStaff } from "./CatalogItemCategoryStaff";
import type { CategoryDTOBase } from "./CategoryDTOBase";

export class CategoryStaff implements CategoryDTOBase {
  constructor(public readonly assignId: number, public readonly categoryName: string, public readonly description: string, public readonly catalogId: number, public readonly hidden: boolean | null, public readonly forReporting: boolean | null, public readonly categoryType: string | null, public readonly itemCategories: Array<CatalogItemCategoryStaff> | null, public readonly agreementCategories: Array<AgreementCategoryStaff> | null) {
    this.cbiServiceContext = null;
    this.itemCategoriesLoaded = this.itemCategories != null;
    this.itemCategoriesCached = this.itemCategories;
    this.agreementCategoriesLoaded = this.agreementCategories != null;
    this.agreementCategoriesCached = this.agreementCategories;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private itemCategoriesLoaded: boolean;
  private itemCategoriesCached: Array<CatalogItemCategoryStaff> | null;
  private agreementCategoriesLoaded: boolean;
  private agreementCategoriesCached: Array<AgreementCategoryStaff> | null;
  async itemCategoriesLazy(): Promise<Array<CatalogItemCategoryStaff>> {
    if (!this.itemCategoriesLoaded) {
      this.itemCategoriesCached = await this.cbiServiceContext!.catalogService().getCategoryStaffItemCategories(this.assignId);
      this.itemCategoriesLoaded = true;
    }
    return this.itemCategoriesCached!;
  }
  async agreementCategoriesLazy(): Promise<Array<AgreementCategoryStaff>> {
    if (!this.agreementCategoriesLoaded) {
      this.agreementCategoriesCached = await this.cbiServiceContext!.catalogService().getCategoryStaffAgreementCategories(this.assignId);
      this.agreementCategoriesLoaded = true;
    }
    return this.agreementCategoriesCached!;
  }
}
